(function () {
    'use strict';
    angular.module('app').controller('PopLockerProviderDetailsController', PopLockerProviderDetailsController);
    PopLockerProviderDetailsController.$inject = [
        'PopLockerService',
        '$routeParams',
        'ProviderLocationsTable'
    ];

    function PopLockerProviderDetailsController(
        PopLockerService,
        $routeParams,
        ProviderLocationsTable
    ) {
        const vm = this;

        vm.id = $routeParams.id;
        console.log($routeParams)
        vm.submit = submit;
        init();

        function init() {
            getPopLockerProviderDetails();
            initTable();
        }

        function initTable() {
            vm.ProviderLocationsTable = new ProviderLocationsTable().tableData;
        }

        function getPopLockerProviderDetails() {
            PopLockerService.details(vm.id,
                res => {
                    vm.providerDetails = res
                }, err => {
                    console.log(err)
                })
        }

        function submit() {
            vm.savingData = true
            if (!vm.id) {
                create(vm.providerDetails)
            } else {
                update()
            }
        }

        function create(data) {
            PopLockerService.createProvider(data,
                res => {
                    console.log(res)
                    vm.savingData = false
                }, err => {
                    console.log(err)
                    vm.savingData = false
                });
        }

        function update() {
            PopLockerService.updateById(vm.id,
                res => {
                    console.log(res)
                    vm.savingData = false
                }, err => {
                    console.log(err)
                    vm.savingData = false;
                }, vm.providerDetails);
        }
    }
})();



// WEBPACK FOOTER //
// ./js/controllers/carriers/PopLockerProviderDetailsController.js